// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as BugTracker from "../../core/BugTracker.res.js";
import * as Pervasives from "@rescript/runtime/lib/es6/Pervasives.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as OrderEdit__Queries from "../../app/Order/OrderEdit__Queries.res.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as Accounting__Serializer from "@wino/accounting/src/Accounting__Serializer.res.js";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";

let UpdateOrderMutation_IdNotFound = /* @__PURE__ */Primitive_exceptions.create("OrderMutations.UpdateOrderMutation_IdNotFound");

let Raw = {};

let query = Client.gql(["mutation CreateOrderMutation($input: InputCreateOrder!)  {\ncreateOrder(input: $input)  {\n__typename  \nid  \nformattedName  \nshopName  \nsupplierCompanyName  \nissueDate  \nreceptionFinishedAt  \nestimatedReceptionDate  \nformattedStatus  \nformattedTotalAmountIncludingTaxes  \ntotalProductsQuantity  \ntotalProductsExpectedQuantity  \nsupplier  {\n__typename  \nid  \n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.createOrder;
  let value$2 = value$1.receptionFinishedAt;
  let value$3 = value$1.formattedStatus;
  let value$4 = value$1.supplier;
  return {
    createOrder: {
      __typename: value$1.__typename,
      id: value$1.id,
      formattedName: value$1.formattedName,
      shopName: value$1.shopName,
      supplierCompanyName: value$1.supplierCompanyName,
      issueDate: Scalar.Datetime.parse(value$1.issueDate),
      receptionFinishedAt: !(value$2 == null) ? Scalar.Datetime.parse(value$2) : undefined,
      estimatedReceptionDate: Scalar.Datetime.parse(value$1.estimatedReceptionDate),
      formattedStatus: value$3.map(value => {
        switch (value) {
          case "ACCEPTED" :
            return "ACCEPTED";
          case "ARCHIVED" :
            return "ARCHIVED";
          case "DRAFT" :
            return "DRAFT";
          case "FINALIZED" :
            return "FINALIZED";
          case "NOT_RECEIVED" :
            return "NOT_RECEIVED";
          case "PAID" :
            return "PAID";
          case "RECEIVED" :
            return "RECEIVED";
          case "RECEIVING" :
            return "RECEIVING";
          case "REFUSED" :
            return "REFUSED";
          case "SENT" :
            return "SENT";
          case "TO_PAY" :
            return "TO_PAY";
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
      }),
      formattedTotalAmountIncludingTaxes: value$1.formattedTotalAmountIncludingTaxes,
      totalProductsQuantity: value$1.totalProductsQuantity,
      totalProductsExpectedQuantity: value$1.totalProductsExpectedQuantity,
      supplier: !(value$4 == null) ? ({
          __typename: value$4.__typename,
          id: value$4.id
        }) : undefined
    }
  };
}

function serialize(value) {
  let value$1 = value.createOrder;
  let value$2 = value$1.supplier;
  let supplier;
  if (value$2 !== undefined) {
    let value$3 = value$2.id;
    let value$4 = value$2.__typename;
    supplier = {
      __typename: value$4,
      id: value$3
    };
  } else {
    supplier = null;
  }
  let value$5 = value$1.totalProductsExpectedQuantity;
  let value$6 = value$1.totalProductsQuantity;
  let value$7 = value$1.formattedTotalAmountIncludingTaxes;
  let value$8 = value$1.formattedStatus;
  let formattedStatus = value$8.map(value => {
    if (value === "TO_PAY") {
      return "TO_PAY";
    } else if (value === "DRAFT") {
      return "DRAFT";
    } else if (value === "NOT_RECEIVED") {
      return "NOT_RECEIVED";
    } else if (value === "REFUSED") {
      return "REFUSED";
    } else if (value === "FINALIZED") {
      return "FINALIZED";
    } else if (value === "ACCEPTED") {
      return "ACCEPTED";
    } else if (value === "PAID") {
      return "PAID";
    } else if (value === "RECEIVING") {
      return "RECEIVING";
    } else if (value === "SENT") {
      return "SENT";
    } else if (value === "RECEIVED") {
      return "RECEIVED";
    } else {
      return "ARCHIVED";
    }
  });
  let value$9 = value$1.estimatedReceptionDate;
  let value$10 = Scalar.Datetime.serialize(value$9);
  let value$11 = value$1.receptionFinishedAt;
  let receptionFinishedAt = value$11 !== undefined ? Scalar.Datetime.serialize(value$11) : null;
  let value$12 = value$1.issueDate;
  let value$13 = Scalar.Datetime.serialize(value$12);
  let value$14 = value$1.supplierCompanyName;
  let value$15 = value$1.shopName;
  let value$16 = value$1.formattedName;
  let value$17 = value$1.id;
  let value$18 = value$1.__typename;
  let createOrder = {
    __typename: value$18,
    id: value$17,
    formattedName: value$16,
    shopName: value$15,
    supplierCompanyName: value$14,
    issueDate: value$13,
    receptionFinishedAt: receptionFinishedAt,
    estimatedReceptionDate: value$10,
    formattedStatus: formattedStatus,
    formattedTotalAmountIncludingTaxes: value$7,
    totalProductsQuantity: value$6,
    totalProductsExpectedQuantity: value$5,
    supplier: supplier
  };
  return {
    createOrder: createOrder
  };
}

function serializeInputObjectInputCreateOrder(inp) {
  let a = inp.condition;
  let a$1 = inp.noteForSupplier;
  let a$2 = inp.note;
  return {
    issueDate: inp.issueDate,
    estimatedReceptionDate: inp.estimatedReceptionDate,
    condition: a !== undefined ? a : undefined,
    noteForSupplier: a$1 !== undefined ? a$1 : undefined,
    note: a$2 !== undefined ? a$2 : undefined,
    cart: inp.cart,
    supplierId: inp.supplierId,
    deviceId: inp.deviceId,
    shopId: inp.shopId
  };
}

function serializeVariables(inp) {
  return {
    input: serializeInputObjectInputCreateOrder(inp.input)
  };
}

function makeVariables(input, param) {
  return {
    input: input
  };
}

function makeInputObjectInputCreateOrder(issueDate, estimatedReceptionDate, condition, noteForSupplier, note, cart, supplierId, deviceId, shopId, param) {
  return {
    issueDate: issueDate,
    estimatedReceptionDate: estimatedReceptionDate,
    condition: condition,
    noteForSupplier: noteForSupplier,
    note: note,
    cart: cart,
    supplierId: supplierId,
    deviceId: deviceId,
    shopId: shopId
  };
}

let CreateOrderMutation_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputCreateOrder: serializeInputObjectInputCreateOrder,
  makeVariables: makeVariables,
  makeInputObjectInputCreateOrder: makeInputObjectInputCreateOrder
};

let include = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let CreateOrderMutation_useWithVariables = include.useWithVariables;

let CreateOrderMutation = {
  CreateOrderMutation_inner: CreateOrderMutation_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputCreateOrder: serializeInputObjectInputCreateOrder,
  makeVariables: makeVariables,
  makeInputObjectInputCreateOrder: makeInputObjectInputCreateOrder,
  use: use,
  useWithVariables: CreateOrderMutation_useWithVariables
};

let Raw$1 = {};

let query$1 = Client.gql(["mutation UpdateOrderMutation($id: ID!, $input: InputUpdateOrder!)  {\nupdateOrder(id: $id, input: $input)  {\n__typename  \nid  \nformattedName  \ncondition  \nnoteForSupplier  \nsupplierNote  \nsupplier  {\n__typename  \nid  \n}\n\nissueDate  \nestimatedReceptionDate  \nnote  \ncart  \nupdatedAt  \n}\n\n}\n"]);

function parse$1(value) {
  let value$1 = value.updateOrder;
  let value$2 = value$1.condition;
  let value$3 = value$1.noteForSupplier;
  let value$4 = value$1.supplierNote;
  let value$5 = value$1.supplier;
  let value$6 = value$1.note;
  return {
    updateOrder: {
      __typename: value$1.__typename,
      id: value$1.id,
      formattedName: value$1.formattedName,
      condition: !(value$2 == null) ? Scalar.Text.parse(value$2) : undefined,
      noteForSupplier: !(value$3 == null) ? Scalar.Text.parse(value$3) : undefined,
      supplierNote: !(value$4 == null) ? value$4 : undefined,
      supplier: !(value$5 == null) ? ({
          __typename: value$5.__typename,
          id: value$5.id
        }) : undefined,
      issueDate: Scalar.Datetime.parse(value$1.issueDate),
      estimatedReceptionDate: Scalar.Datetime.parse(value$1.estimatedReceptionDate),
      note: !(value$6 == null) ? Scalar.Text.parse(value$6) : undefined,
      cart: Scalar.Text.parse(value$1.cart),
      updatedAt: Scalar.Datetime.parse(value$1.updatedAt)
    }
  };
}

function serialize$1(value) {
  let value$1 = value.updateOrder;
  let value$2 = value$1.updatedAt;
  let value$3 = Scalar.Datetime.serialize(value$2);
  let value$4 = value$1.cart;
  let value$5 = Scalar.Text.serialize(value$4);
  let value$6 = value$1.note;
  let note = value$6 !== undefined ? Scalar.Text.serialize(value$6) : null;
  let value$7 = value$1.estimatedReceptionDate;
  let value$8 = Scalar.Datetime.serialize(value$7);
  let value$9 = value$1.issueDate;
  let value$10 = Scalar.Datetime.serialize(value$9);
  let value$11 = value$1.supplier;
  let supplier;
  if (value$11 !== undefined) {
    let value$12 = value$11.id;
    let value$13 = value$11.__typename;
    supplier = {
      __typename: value$13,
      id: value$12
    };
  } else {
    supplier = null;
  }
  let value$14 = value$1.supplierNote;
  let supplierNote = value$14 !== undefined ? value$14 : null;
  let value$15 = value$1.noteForSupplier;
  let noteForSupplier = value$15 !== undefined ? Scalar.Text.serialize(value$15) : null;
  let value$16 = value$1.condition;
  let condition = value$16 !== undefined ? Scalar.Text.serialize(value$16) : null;
  let value$17 = value$1.formattedName;
  let value$18 = value$1.id;
  let value$19 = value$1.__typename;
  let updateOrder = {
    __typename: value$19,
    id: value$18,
    formattedName: value$17,
    condition: condition,
    noteForSupplier: noteForSupplier,
    supplierNote: supplierNote,
    supplier: supplier,
    issueDate: value$10,
    estimatedReceptionDate: value$8,
    note: note,
    cart: value$5,
    updatedAt: value$3
  };
  return {
    updateOrder: updateOrder
  };
}

function serializeInputObjectInputUpdateOrder(inp) {
  let a = inp.issueDate;
  let a$1 = inp.estimatedReceptionDate;
  let a$2 = inp.condition;
  let a$3 = inp.noteForSupplier;
  let a$4 = inp.note;
  let a$5 = inp.cart;
  let a$6 = inp.supplierId;
  return {
    issueDate: a !== undefined ? a : undefined,
    estimatedReceptionDate: a$1 !== undefined ? a$1 : undefined,
    condition: a$2 !== undefined ? a$2 : undefined,
    noteForSupplier: a$3 !== undefined ? a$3 : undefined,
    note: a$4 !== undefined ? a$4 : undefined,
    cart: a$5 !== undefined ? a$5 : undefined,
    supplierId: a$6 !== undefined ? a$6 : undefined
  };
}

function serializeVariables$1(inp) {
  return {
    id: inp.id,
    input: serializeInputObjectInputUpdateOrder(inp.input)
  };
}

function makeVariables$1(id, input, param) {
  return {
    id: id,
    input: input
  };
}

function makeInputObjectInputUpdateOrder(issueDate, estimatedReceptionDate, condition, noteForSupplier, note, cart, supplierId, param) {
  return {
    issueDate: issueDate,
    estimatedReceptionDate: estimatedReceptionDate,
    condition: condition,
    noteForSupplier: noteForSupplier,
    note: note,
    cart: cart,
    supplierId: supplierId
  };
}

let UpdateOrderMutation_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputUpdateOrder: serializeInputObjectInputUpdateOrder,
  makeVariables: makeVariables$1,
  makeInputObjectInputUpdateOrder: makeInputObjectInputUpdateOrder
};

let include$1 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let use$1 = include$1.use;

let UpdateOrderMutation_useWithVariables = include$1.useWithVariables;

let UpdateOrderMutation = {
  UpdateOrderMutation_inner: UpdateOrderMutation_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputUpdateOrder: serializeInputObjectInputUpdateOrder,
  makeVariables: makeVariables$1,
  makeInputObjectInputUpdateOrder: makeInputObjectInputUpdateOrder,
  use: use$1,
  useWithVariables: UpdateOrderMutation_useWithVariables
};

let Raw$2 = {};

let query$2 = Client.gql(["mutation MoveOrderMutation($id: ID!, $action: OrderAction)  {\nmoveOrder(id: $id, action: $action)  {\n__typename  \nid  \nformattedStatus  \n}\n\n}\n"]);

function parse$2(value) {
  let value$1 = value.moveOrder;
  let value$2 = value$1.formattedStatus;
  return {
    moveOrder: {
      __typename: value$1.__typename,
      id: value$1.id,
      formattedStatus: value$2.map(value => {
        switch (value) {
          case "ACCEPTED" :
            return "ACCEPTED";
          case "ARCHIVED" :
            return "ARCHIVED";
          case "DRAFT" :
            return "DRAFT";
          case "FINALIZED" :
            return "FINALIZED";
          case "NOT_RECEIVED" :
            return "NOT_RECEIVED";
          case "PAID" :
            return "PAID";
          case "RECEIVED" :
            return "RECEIVED";
          case "RECEIVING" :
            return "RECEIVING";
          case "REFUSED" :
            return "REFUSED";
          case "SENT" :
            return "SENT";
          case "TO_PAY" :
            return "TO_PAY";
          default:
            return {
              NAME: "FutureAddedValue",
              VAL: value
            };
        }
      })
    }
  };
}

function serialize$2(value) {
  let value$1 = value.moveOrder;
  let value$2 = value$1.formattedStatus;
  let formattedStatus = value$2.map(value => {
    if (typeof value === "object") {
      return value.VAL;
    } else if (value === "TO_PAY") {
      return "TO_PAY";
    } else if (value === "DRAFT") {
      return "DRAFT";
    } else if (value === "NOT_RECEIVED") {
      return "NOT_RECEIVED";
    } else if (value === "REFUSED") {
      return "REFUSED";
    } else if (value === "FINALIZED") {
      return "FINALIZED";
    } else if (value === "ACCEPTED") {
      return "ACCEPTED";
    } else if (value === "PAID") {
      return "PAID";
    } else if (value === "RECEIVING") {
      return "RECEIVING";
    } else if (value === "SENT") {
      return "SENT";
    } else if (value === "RECEIVED") {
      return "RECEIVED";
    } else {
      return "ARCHIVED";
    }
  });
  let value$3 = value$1.id;
  let value$4 = value$1.__typename;
  let moveOrder = {
    __typename: value$4,
    id: value$3,
    formattedStatus: formattedStatus
  };
  return {
    moveOrder: moveOrder
  };
}

function serializeVariables$2(inp) {
  let a = inp.action;
  return {
    id: inp.id,
    action: a !== undefined ? (
        a === "FINISH_RECEPTION" ? "FINISH_RECEPTION" : (
            a === "START_RECEPTION" ? "START_RECEPTION" : (
                a === "CANCEL" ? "CANCEL" : (
                    a === "PAY" ? "PAY" : (
                        a === "REFUSE" ? "REFUSE" : (
                            a === "SEND" ? "SEND" : (
                                a === "ACCEPT" ? "ACCEPT" : "FINALIZE"
                              )
                          )
                      )
                  )
              )
          )
      ) : undefined
  };
}

function makeVariables$2(id, action, param) {
  return {
    id: id,
    action: action
  };
}

let MoveOrderMutation_inner = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2
};

let include$2 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$2,
  Raw: Raw$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2
});

let use$2 = include$2.use;

let MoveOrderMutation_useWithVariables = include$2.useWithVariables;

let MoveOrderMutation = {
  MoveOrderMutation_inner: MoveOrderMutation_inner,
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2,
  use: use$2,
  useWithVariables: MoveOrderMutation_useWithVariables
};

let Raw$3 = {};

let query$3 = Client.gql(["mutation ArchiveOrderMutation($id: ID!)  {\narchiveOrder(id: $id)  {\n__typename  \nid  \nformattedStatus  \n}\n\n}\n"]);

function parse$3(value) {
  let value$1 = value.archiveOrder;
  let value$2 = value$1.formattedStatus;
  return {
    archiveOrder: {
      __typename: value$1.__typename,
      id: value$1.id,
      formattedStatus: value$2.map(value => {
        switch (value) {
          case "ACCEPTED" :
            return "ACCEPTED";
          case "ARCHIVED" :
            return "ARCHIVED";
          case "DRAFT" :
            return "DRAFT";
          case "FINALIZED" :
            return "FINALIZED";
          case "NOT_RECEIVED" :
            return "NOT_RECEIVED";
          case "PAID" :
            return "PAID";
          case "RECEIVED" :
            return "RECEIVED";
          case "RECEIVING" :
            return "RECEIVING";
          case "REFUSED" :
            return "REFUSED";
          case "SENT" :
            return "SENT";
          case "TO_PAY" :
            return "TO_PAY";
          default:
            return {
              NAME: "FutureAddedValue",
              VAL: value
            };
        }
      })
    }
  };
}

function serialize$3(value) {
  let value$1 = value.archiveOrder;
  let value$2 = value$1.formattedStatus;
  let formattedStatus = value$2.map(value => {
    if (typeof value === "object") {
      return value.VAL;
    } else if (value === "TO_PAY") {
      return "TO_PAY";
    } else if (value === "DRAFT") {
      return "DRAFT";
    } else if (value === "NOT_RECEIVED") {
      return "NOT_RECEIVED";
    } else if (value === "REFUSED") {
      return "REFUSED";
    } else if (value === "FINALIZED") {
      return "FINALIZED";
    } else if (value === "ACCEPTED") {
      return "ACCEPTED";
    } else if (value === "PAID") {
      return "PAID";
    } else if (value === "RECEIVING") {
      return "RECEIVING";
    } else if (value === "SENT") {
      return "SENT";
    } else if (value === "RECEIVED") {
      return "RECEIVED";
    } else {
      return "ARCHIVED";
    }
  });
  let value$3 = value$1.id;
  let value$4 = value$1.__typename;
  let archiveOrder = {
    __typename: value$4,
    id: value$3,
    formattedStatus: formattedStatus
  };
  return {
    archiveOrder: archiveOrder
  };
}

function serializeVariables$3(inp) {
  return {
    id: inp.id
  };
}

function makeVariables$3(id, param) {
  return {
    id: id
  };
}

let ArchiveOrderMutation_inner = {
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3
};

let include$3 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$3,
  Raw: Raw$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3
});

let use$3 = include$3.use;

let ArchiveOrderMutation_useWithVariables = include$3.useWithVariables;

let ArchiveOrderMutation = {
  ArchiveOrderMutation_inner: ArchiveOrderMutation_inner,
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3,
  use: use$3,
  useWithVariables: ArchiveOrderMutation_useWithVariables
};

let Raw$4 = {};

let query$4 = Client.gql(["mutation UnarchiveOrderMutation($id: ID!)  {\nunarchiveOrder(id: $id)  {\n__typename  \nid  \nformattedStatus  \n}\n\n}\n"]);

function parse$4(value) {
  let value$1 = value.unarchiveOrder;
  let value$2 = value$1.formattedStatus;
  return {
    unarchiveOrder: {
      __typename: value$1.__typename,
      id: value$1.id,
      formattedStatus: value$2.map(value => {
        switch (value) {
          case "ACCEPTED" :
            return "ACCEPTED";
          case "ARCHIVED" :
            return "ARCHIVED";
          case "DRAFT" :
            return "DRAFT";
          case "FINALIZED" :
            return "FINALIZED";
          case "NOT_RECEIVED" :
            return "NOT_RECEIVED";
          case "PAID" :
            return "PAID";
          case "RECEIVED" :
            return "RECEIVED";
          case "RECEIVING" :
            return "RECEIVING";
          case "REFUSED" :
            return "REFUSED";
          case "SENT" :
            return "SENT";
          case "TO_PAY" :
            return "TO_PAY";
          default:
            return {
              NAME: "FutureAddedValue",
              VAL: value
            };
        }
      })
    }
  };
}

function serialize$4(value) {
  let value$1 = value.unarchiveOrder;
  let value$2 = value$1.formattedStatus;
  let formattedStatus = value$2.map(value => {
    if (typeof value === "object") {
      return value.VAL;
    } else if (value === "TO_PAY") {
      return "TO_PAY";
    } else if (value === "DRAFT") {
      return "DRAFT";
    } else if (value === "NOT_RECEIVED") {
      return "NOT_RECEIVED";
    } else if (value === "REFUSED") {
      return "REFUSED";
    } else if (value === "FINALIZED") {
      return "FINALIZED";
    } else if (value === "ACCEPTED") {
      return "ACCEPTED";
    } else if (value === "PAID") {
      return "PAID";
    } else if (value === "RECEIVING") {
      return "RECEIVING";
    } else if (value === "SENT") {
      return "SENT";
    } else if (value === "RECEIVED") {
      return "RECEIVED";
    } else {
      return "ARCHIVED";
    }
  });
  let value$3 = value$1.id;
  let value$4 = value$1.__typename;
  let unarchiveOrder = {
    __typename: value$4,
    id: value$3,
    formattedStatus: formattedStatus
  };
  return {
    unarchiveOrder: unarchiveOrder
  };
}

function serializeVariables$4(inp) {
  return {
    id: inp.id
  };
}

function makeVariables$4(id, param) {
  return {
    id: id
  };
}

let UnarchiveOrderMutation_inner = {
  Raw: Raw$4,
  query: query$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$4,
  makeVariables: makeVariables$4
};

let include$4 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$4,
  Raw: Raw$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$4
});

let use$4 = include$4.use;

let UnarchiveOrderMutation_useWithVariables = include$4.useWithVariables;

let UnarchiveOrderMutation = {
  UnarchiveOrderMutation_inner: UnarchiveOrderMutation_inner,
  Raw: Raw$4,
  query: query$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$4,
  makeVariables: makeVariables$4,
  use: use$4,
  useWithVariables: UnarchiveOrderMutation_useWithVariables
};

function useCreate() {
  let match = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let result = match[1];
  let mutate = match[0];
  let filterGlobalDiscount = cart => {
    let newrecord = {...cart};
    newrecord.discounts = cart.discounts.filter(discount => {
      let amount = discount.amount;
      if (amount !== undefined) {
        return Primitive_option.valFromOption(amount).toNumber() > 0;
      } else {
        return false;
      }
    });
    return newrecord;
  };
  return React.useCallback((param, state) => {
    let input = makeInputObjectInputCreateOrder(Scalar.Datetime.serialize(state.issueDate), Scalar.Datetime.serialize(state.estimatedReceptionDate), state.condition, state.noteForSupplier, state.note, Scalar.Text.serialize(Accounting__Serializer.serialize(filterGlobalDiscount(state.cart))), state.supplierId, state.deviceId, state.shopId, undefined);
    if (state.deviceId === "") {
      return Future.make(resolve => {
        BugTracker.reportErrorMessage("Empty deviceId error with saved order state: " + Stdlib_Option.getOr(Json.stringifyAny(input), ""));
        resolve({
          TAG: "Error",
          _0: I18n.t("Something wrong happened, please try again or contact the support through the bottom left side corner chat button.")
        });
      });
    } else {
      return Future.tapOk(Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
        input: input
      })), undefined, param => param.createOrder.id), param => {
        let match = result.client;
        if (match !== undefined) {
          match.rescript_resetStore();
          return;
        }
      });
    }
  }, []);
}

function useUpdate(id, param) {
  let match = use$1(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutate = match[0];
  let filterGlobalDiscount = cart => {
    let newrecord = {...cart};
    newrecord.discounts = cart.discounts.filter(discount => {
      let amount = discount.amount;
      if (amount !== undefined) {
        return Primitive_option.valFromOption(amount).toNumber() > 0;
      } else {
        return false;
      }
    });
    return newrecord;
  };
  return React.useCallback((param, state) => {
    let input = makeInputObjectInputUpdateOrder(Scalar.Datetime.serialize(state.issueDate), Scalar.Datetime.serialize(state.estimatedReceptionDate), state.condition, state.noteForSupplier, state.note, Scalar.Text.serialize(Accounting__Serializer.serialize(filterGlobalDiscount(state.cart))), state.supplierId, undefined);
    let tmp;
    if (id !== undefined) {
      tmp = id;
    } else {
      throw {
        RE_EXN_ID: UpdateOrderMutation_IdNotFound,
        Error: new Error()
      };
    }
    return Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
      id: tmp,
      input: input
    })), undefined, param => param.updateOrder.id);
  }, []);
}

function useMove(id, action) {
  let match = use$2(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutate = match[0];
  return React.useCallback((param, param$1) => {
    let id$1 = id !== undefined ? id : Pervasives.failwith("The order should be saved before continuing.");
    return Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, [OrderEdit__Queries.OrderQuery.refetchQueryDescription(undefined, undefined, OrderEdit__Queries.OrderQuery.makeVariables(id$1, undefined))], undefined, {
      id: id$1,
      action: action
    })), undefined, param => param.moveOrder.id);
  }, [action]);
}

function useArchive(id, param) {
  let match = use$3(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutate = match[0];
  return React.useCallback(() => {
    let id$1 = id !== undefined ? id : Pervasives.failwith("The order should be saved before archiving.");
    return Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, [OrderEdit__Queries.OrderQuery.refetchQueryDescription(undefined, undefined, OrderEdit__Queries.OrderQuery.makeVariables(id$1, undefined))], undefined, {
      id: id$1
    })), undefined, param => id$1);
  }, []);
}

function useUnarchive(id, param) {
  let match = use$4(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutate = match[0];
  return React.useCallback(() => {
    let id$1 = id !== undefined ? id : Pervasives.failwith("The order should be saved before unarchiving.");
    return Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, [OrderEdit__Queries.OrderQuery.refetchQueryDescription(undefined, undefined, OrderEdit__Queries.OrderQuery.makeVariables(id$1, undefined))], undefined, {
      id: id$1
    })), undefined, param => id$1);
  }, []);
}

let OrderQuery;

export {
  OrderQuery,
  UpdateOrderMutation_IdNotFound,
  CreateOrderMutation,
  UpdateOrderMutation,
  MoveOrderMutation,
  ArchiveOrderMutation,
  UnarchiveOrderMutation,
  useCreate,
  useUpdate,
  useMove,
  useArchive,
  useUnarchive,
}
/* query Not a pure module */
